import API_URL from "../config";
import axios from "axios";

// import { socket } from "./../socket";
import { getCookie } from "./../utils/cookies";

export const productTableApi = async (tcp, client, fromDate, toDate, selectedProduct = '', fournisseur = 'all') => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    if (fromDate && toDate) {
      const res = await axios.get(
        `${API_URL}/api/V2/dashboard/ProductsTable/${id}/${iv}?TCP=${tcp}&Client=${client}&filtredDate=["${fromDate}", "${toDate}"]&selectedProduct=${selectedProduct}&Fournisseur=${fournisseur}`,
        option
      );
      return res.data;
    }

    const res = await axios.get(
      `${API_URL}/api/V2/dashboard/ProductsTable/${id}/${iv}?TCP=${tcp}&Client=${client}&selectedProduct=${selectedProduct}&Fournisseur=${fournisseur}`,
      option
    );
    return res.data;
  } catch (err) {
    return false;
  }
};

export const productTableXcelApi = async (tcp, client, fromDate, toDate, fournisseur = 'all') => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    if (fromDate && toDate) {
      const res = await axios.get(
        `${API_URL}/api/V2/dashboard/ProductsTableToExcel/${id}/${iv}?TCP=${tcp}&Client=${client}&filtredDate=["${fromDate}", "${toDate}"]&filterBy=${client}&Fournisseur=${fournisseur}`,
        option
      );
      return res.data;
    }

    const res = await axios.get(
      `${API_URL}/api/V2/dashboard/ProductsTableToExcel/${id}/${iv}?TCP=${tcp}&Client=${client}&filterBy=${client}&Fournisseur=${fournisseur}`,
      option
    );
    return res.data;
  } catch (err) {
    return false;
  }
};

export const tcpTableApi = async (selectedProducts, fromDate, toDate) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // Convert array of products to query parameter format
    const productsParam = Array.isArray(selectedProducts) && selectedProducts.length > 0 
      ? selectedProducts.join(',') 
      : '';

    if (fromDate && toDate) {
      const res = await axios.get(
        `${API_URL}/api/V2/dashboard/TcpTableByProductCategory/${id}/${iv}?selectedProduct=${productsParam}&filtredDate=["${fromDate}", "${toDate}"]&filterBy=${productsParam}`,
        option
      );
      return res.data;
    }

    const res = await axios.get(
      `${API_URL}/api/V2/dashboard/TcpTableByProductCategory/${id}/${iv}?selectedProduct=${productsParam}&filterBy=${productsParam}`,
      option
    );
    return res.data;
  } catch (err) {
    return false;
  }
};

export const tcpTableXcelApi = async (selectedProducts, fromDate, toDate) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // Convert array of products to query parameter format
    const productsParam = Array.isArray(selectedProducts) && selectedProducts.length > 0 
      ? selectedProducts.join(',') 
      : '';

    if (fromDate && toDate) {
      const res = await axios.get(
        `${API_URL}/api/V2/dashboard/TcpTableByProductCategoryToExcel/${id}/${iv}?selectedProduct=${productsParam}&filtredDate=["${fromDate}", "${toDate}"]&filterBy=${productsParam}`,
        option
      );
      return res.data;
    }

    const res = await axios.get(
      `${API_URL}/api/V2/dashboard/TcpTableByProductCategoryToExcel/${id}/${iv}?selectedProduct=${productsParam}&filterBy=${productsParam}`,
      option
    );
    return res.data;
  } catch (err) {
    return false;
  }
};

export const generaleTableApi = async (fromDate, toDate) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    if (fromDate && toDate) {
      const res = await axios.get(
        `${API_URL}/api/V2/dashboard/GeneraleTable/${id}/${iv}?filtredDate=["${fromDate}", "${toDate}"]`,
        option
      );
      return res.data;
    }

    const res = await axios.get(
      `${API_URL}/api/V2/dashboard/GeneraleTable/${id}/${iv}`,
      option
    );
    return res.data;
  } catch (err) {
    return false;
  }
};

export const generaleTableXcelApi = async (fromDate, toDate) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    if (fromDate && toDate) {
      const res = await axios.get(
        `${API_URL}/api/V2/dashboard/GeneraleTableToExcel/${id}/${iv}?filtredDate=["${fromDate}", "${toDate}"]`,
        option
      );
      return res.data;
    }

    const res = await axios.get(
      `${API_URL}/api/V2/dashboard/GeneraleTableToExcel/${id}/${iv}`,
      option
    );
    return res.data;
  } catch (err) {
    return false;
  }
};

export const getOnePrevisionDataApi = async (object) => {
  try {
    let response = await axios.post(
      `${API_URL}/api/rapport/getOnePrevisionDetails`,
      object
    );

    let json = response.data;
    return json;
  }
  catch (error) {
    throw error
  }
}

export const MobileTcpTableDataApi = async (productTableDataPrevYear, productTableDataQ1, productTableDataQ2, productTableDataQ3, productTableDataQ4, tcpPrevisionData, selectedProductsString) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const bodyObject = {
        productTableDataPrevYear: productTableDataPrevYear,
        productTableDataQ1: productTableDataQ1,
        productTableDataQ2: productTableDataQ2,
        productTableDataQ3: productTableDataQ3,
        productTableDataQ4: productTableDataQ4,
        tcpPrevisionData: tcpPrevisionData,
        selectedProductsString: selectedProductsString
    }

    const res = await axios.post(
      `${API_URL}/api/V2/dashboard/MobileTcpTableData/${id}/${iv}`,
      bodyObject,
      option
    );

    return res.data;
  } catch (error) {
    throw error;
  }
};
